import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import defaultImage from '../../assets/default-image.jpg';
import {baseURL} from '../../misc/http';

const renderList = (listOrganizer) => {
  if (listOrganizer.length){
    return (
      listOrganizer.map((e, index) => (
          <Link className="card card-primary mb-5" to={`/organizer/${e._id}`} style={{color: 'black', width: 370, marginRight: 10, height: 420}}>
            <div className="img-ca">
              <img className="card-img-top" src={e.thumbnail ? baseURL+'/'+e.thumbnail : defaultImage} alt="privy-thumbnail" style={{height:'200px', objectFit: 'cover', width: '100%', borderTopLeftRadius: '8px', borderTopRightRadius: '8px'}} />
            </div>
            <div className="card-body" style={{padding: '15px', position: 'relative'}}>
              <p className="text-muted" style={{fontSize: '12px', textTransform: 'uppercase'}}>{e.type}</p>
              <p style={{fontSize: '18px', fontWeight: '600'}}>{e.companyName}</p>
              <div className="bottom-image-ca" style={{position: 'absolute',bottom:'30px', width: '100%', paddingRight: '30px'}}>
                <label className="text-muted" style={{fontSize: '12px'}}>{e.noRef}</label>
                <div className="space-between"><img className="mt-2" src={e.logo ? baseURL+'/'+ e.logo : defaultImage} alt="logo-privy-colored" style={{width: 'auto', height:'30px'}} />
                  <div className="btn-green">{e.status}</div>
                </div>
              </div>
            </div>
          </Link>
        )
      )
    )
  } else return <div>No Data Founded</div>
}


export default ({listOrganizer}) => {
  return (
    <section className="psre-dua">
    <div className="container">
      <div className="d-lg-block d-md-block d-sm-none d-none">
        <table className="table-borderless w-100 mb-5">
          <tr>
            <td>
              <p className="mb-0" style={{fontSize:'14px', fontWeight:'600'}}>Penyelenggara</p>
            </td>
            <td style={{width: '65%'}}>
              <div style={{borderTop:'1px solid rgba(49, 49, 49, 0.12)', width: '100%'}}></div>
            </td>
            <td class="text-right">
              <Link to='/listPSrE/_' style={{fontSize: '13px', fontWeight: '600', color: '#0085C7'}}>
                Lihat Semua Penyelenggara
              </Link>
            </td>
          </tr>
        </table>
      </div>
      <div className="d-lg-none d-md-none d-sm-block d-block">
        <p style={{fontSize: '14px', fontWeight: '600'}}>Penyelenggara</p>
        {/* <select className="select-primary mt-3 mb-5 form-control" id="" style={{height: 'calc(2.5rem + 8px)', borderColor: 'rgba(49, 49, 49, 0.12)'}}>
          <option value="" hidden="" selected="">Pilih Jenis PSrE</option>
          <option value="">1</option>
        </select> */}
        <Link to='/listPSrE/_' style={{fontSize: '13px', fontWeight: '600', color: '#0085C7'}}>
          Lihat Semua Penyelenggara
        </Link>
      </div><br/>
      <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap'}}>
        {renderList(listOrganizer)}
      </div>
    </div>
  </section>
  )
}
